import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HeadersModule } from '@shared/core/components/headers';
import { LoadersModule } from '@shared/core/components/loaders';
import { AuthBalanceModule } from '../authBalanceValue';

import { AuthAccountBalanceComponent } from './auth-account-balance.shared.component';

@NgModule({
    declarations: [
        AuthAccountBalanceComponent
    ],
    imports: [
        CommonModule,
        HeadersModule,
        LoadersModule,
        AuthBalanceModule,
    ],
    exports: [
        AuthAccountBalanceComponent
    ],
})
export class AuthAccountBalanceModule { }
